var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"posts"},[(_vm.items.length > 0)?_c('Grid',{attrs:{"col":{ default: 6, m: 4 }}},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c(_vm.thumbs.get('default'),{tag:"component",attrs:{"data":item}})],1)}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }